import React, { Component } from 'react';

//import { BrowserRouter as MyRouter} from "react-router-dom";
import { HashRouter as MyRouter } from 'react-router-dom';

import { Route, Switch, Redirect  } from "react-router-dom";

import Splash from '../splash/splash.js';

import HomeWidget from '../home/home.js';

import CreateERC20TokenWidget from '../create-erc20-token/create-erc20-token.js';

import PayWidget from '../pay/pay.js';
import PaymentLinkWidget from '../pay/payment-link.js';
import PaymentQRCodeWidget from '../pay/payment-qrcode.js';

import PlaceOrderWidget from '../place-order/place-order.js';


class RouteHistory {

	constructor(root) {
		this.root = root;
	}

	pop() {
		RouteHistory.todo.pop();
	}

	push(path) {
		let last = this.last();

		if (RouteHistory.todo.length && (RouteHistory.todo[0] == path))
			return;

		if (last == path)
			return;

		//RouteHistory.history.push(path);
		RouteHistory.todo.unshift(path); // last in last out

		this.setState()
	}

	record(path) {
		console.log('route is being served ' + path);

		RouteHistory.history.push(path);
	}

	async setState() {
		if (RouteHistory.todo.length)
			this.root._setState({targetpath: [RouteHistory.todo]});
		else
			this.root._setState({targetpath: null});

	}

	last() {
		return (RouteHistory.history.length ? RouteHistory.history[RouteHistory.history.length - 1] : null);
	}

	jumpto() {
		return (RouteHistory.todo.length ? RouteHistory.todo[RouteHistory.todo.length - 1] : null);
	}
}

RouteHistory.history = [];
RouteHistory.todo = [];

class Root extends React.Component {
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcMyWidget = this.app.getMvcMyWidget;

		this.uuid = this.app.guid();

		this.early_messages = []
		
		// to do jumps
		this.routehistory = new RouteHistory(this);

		this.state = {
				loading: true,
				iSessionPending: false,
				isLoggedIn: false,
				hasFatalError: false,
				fatalError: '',
		};
	}

	async _setState(json) {
		return new Promise((resolve, reject) => {
			this.setState(json, (err, res) => {
				if (err) reject(err); else resolve(res);
			});
		})
	}
	
	// post render commit phase
	componentDidMount() {
		console.log('Root.componentDidMount called');
		let mvcmywidget = this.app.getMvcMyWidget();

		// register to app
		this.app.setVariable('Root',this);

		mvcmywidget.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));

		// listen to external messages (to bufferize for widgets)
		mvcmywidget.registerEventListener('on_handle_message', this.uuid, this.onHandleMessage.bind(this));

		// listen to widget messages
		mvcmywidget.registerEventListener('on_widgetloaded_message', this.uuid, this.onWidgetLoaded.bind(this));


		this.setState({loading: false});
	}

	// end of life
	componentWillUnmount() {
		console.log('Root.componentWillUnmount called');
		let mvcmywidget = this.app.getMvcMyWidget();
		
		mvcmywidget.unregisterEventListener('on_widgetloaded_message', this.uuid);
		mvcmywidget.unregisterEventListener('on_handle_message', this.uuid);
		mvcmywidget.unregisterEventListener('on_refreshPage', this.uuid);
		
		// unregister from app
		this.app.setVariable('Root',null);
	}

	async onRefreshPage() {
		console.log('Root.onRefreshPage called');
		let lastrefresh = Date.now();
		
		await this._setState({lastrefresh: lastrefresh});
	}

	async onHandleMessage(eventname, params) {
		// bufferize
		if (params.noreplay === true)
			return; // for actions like doAmountTransfer

		this.early_messages.push({eventname, params});
	}

	async onWidgetLoaded(eventname, params) {
		// we empty bufferized messages
		let widget_name = params.widget_name;

		console.log('Root.onWidgetLoaded called for: ' + widget_name);

		let _messages_for_widget = this.early_messages;
		this.early_messages = [];

		// send messages now to our internal widget
		let mvcmywidget = this.app.getMvcMyWidget();

		for (var i = 0; i < _messages_for_widget.length; i++) {
			let _eventname = _messages_for_widget[i].eventname;
			let _params = _messages_for_widget[i].params;

			if ((_params.action != 'set_start_conditions')
			&& (_params.action != 'set_start_conditions_parameter'))
			mvcmywidget.signalEvent(_eventname, _params);
		}

		// signal parent widget is loaded
		this.app.postParent({action: 'receive_event', event_name: 'on_widget_loaded', widget_name});

	}

	// navigation
	_getRoutePathFromName(route){
		for (var i = 0; i < Root.routes.length; i++){
			var item = Root.routes[i];
			if (item.name == route)
				return item.path
		} 
	} 
	async _gotoRoute(route, params) {
		var path = this._getRoutePathFromName(route);

		if (path) {
			this.routehistory.push(path);

			await this.app.refreshPage();
		}
	}
	

	// rendering
	onRouteSwitch(path) {
		this.routehistory.record(path);
	}

	renderRoute() {
		if (this.state.loading) {
			return (
				<div className="RootContainer">
					<Splash 
						app = {this.app}
						msg = 'loading widget...'
					/>
				</div>
			);
		}

		let jumpto = this.routehistory.jumpto();

		if (jumpto) {
			this.routehistory.pop();
			return (<Redirect to={jumpto} />);
		}
		else {
			let start_conditions = this.app.getStartConditions();
			let widget_uuid = (start_conditions && start_conditions.widget_uuid ? start_conditions.widget_uuid : this.app.guid());
			// today (2021.07.03) we have only 1 widget_uuid per my-widget app (hence per start_conditions)
			// if we happen to support multiple widgets in a single app
			// we can use /route/:uuid to switch between the different instances

			return (
				<Switch>
					{Root.routes.map((route, index) => {
							return <Route exact path={route.path} key={route.name} render={(props) => { return (<route.widget {...props} app={this.app} uuid={widget_uuid}/>);}} />
						}	
					)}
				</Switch>
			);
		}
	}

    render() {

		const {isSessionPending, hasFatalError} = this.state;
		
		if (isSessionPending) {
			return (
				<div className="RootContainer">
					<div>creating session...</div>
				</div>
			);
		}
		else {
			if (!hasFatalError) {
				return (
					<div className="RootContainer">
						<MyRouter>
						{this.renderRoute()}
						</MyRouter>
					</div>
				);
			}
			else{
				return (
					<div className="RootContainer">
						<div>Fatal error</div>
					</div>
				);
			}
		}	 	
	}
}

Root.routes = [
	{
		name: 'root',
		path: '/',
		widget: HomeWidget

	},
	{
		name: 'home',
		path: '/home',
		widget: HomeWidget

	},
	{
		name: 'create-erc20-token',
		path: '/create-erc20-token',
		widget: CreateERC20TokenWidget

	},
	{
		name: 'pay',
		path: '/pay',
		widget: PayWidget

	},
	{
		name: 'payment-link',
		path: '/payment-link',
		widget: PaymentLinkWidget

	},
	{
		name: 'payment-qrcode',
		path: '/payment-qrcode',
		widget: PaymentQRCodeWidget

	},
	{
		name: 'place-order',
		path: '/place-order',
		widget: PlaceOrderWidget

	}
];

export default Root;